import React from 'react'
import { connect } from '@cerebral/react'
import { signal, state } from 'cerebral/tags'
import { t } from '@billes/translator-client'
import isAdmin from 'utils/isAdmin'
import { Delete } from 'components/Icons'

export default connect(
  {
    hasSelectedFiles: state`media.currentFile`,
    deleteSelectedFiles: signal`media.askDeleteFiles`,
    group: state`app.user.group`
  },
  ({ deleteSelectedFiles, group, hasSelectedFiles }) =>
    isAdmin(group) ? (
      <div
        style={{ height: 48, cursor: hasSelectedFiles ? 'pointer' : 'default' }}
        onClick={_ => {
          if (hasSelectedFiles) deleteSelectedFiles()
        }}
        title={t('bms.media.titles.deleteSelectedFiles')}
      >
        <Delete
          viewBox={'-4 0 24 24'}
          style={{
            height: 35,
            width: 35,
            fill: hasSelectedFiles ? '#ccc' : '#efefef'
          }}
        />
      </div>
    ) : null
)



// WEBPACK FOOTER //
// ./src/components/SwiftMenu/TrashCan/index.js